var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductsEmpty = function SvgProductsEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "#102262",
    strokeWidth: 2.5,
    transform: "matrix(-1 0 0 1 40 23.998)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M47.339 14.212c.84.069 1.683.004 2.495-.188.875-.206 1.839-.05 2.424.633a26.634 26.634 0 0 1 4.925 8.55c.334.956-.152 1.97-.934 2.614A7.984 7.984 0 0 0 53.333 32a7.984 7.984 0 0 0 2.916 6.177c.782.644 1.268 1.658.934 2.615a26.636 26.636 0 0 1-4.925 8.549c-.584.683-1.548.839-2.423.633A7.972 7.972 0 0 0 44 50.83a7.978 7.978 0 0 0-3.795 5.127c-.203.877-.77 1.673-1.643 1.894-2.1.531-4.298.813-6.562.813-2.265 0-4.463-.282-6.562-.813-.873-.22-1.44-1.017-1.643-1.894a8.046 8.046 0 0 0-.64-1.778M40.95 10.02a8.036 8.036 0 0 1-.743-1.981c-.203-.877-.771-1.673-1.644-1.893A26.72 26.72 0 0 0 32 5.332a26.72 26.72 0 0 0-6.563.813c-.872.221-1.44 1.017-1.643 1.894A7.978 7.978 0 0 1 20 13.165a7.972 7.972 0 0 1-5.835.859c-.875-.206-1.838-.05-2.423.633a26.637 26.637 0 0 0-4.925 8.55c-.335.956.151 1.97.933 2.614A7.984 7.984 0 0 1 10.666 32a7.984 7.984 0 0 1-2.916 6.177c-.782.644-1.268 1.658-.934 2.615a26.637 26.637 0 0 0 4.925 8.55c.585.682 1.549.838 2.424.632a8.011 8.011 0 0 1 2.785-.16"
  })));
};
export default SvgProductsEmpty;